var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"draft-badge"},[_vm._v("Draft")])
}
var staticRenderFns = []

export { render, staticRenderFns }